/**
 * Models information about a multisig wallet.
 */
export default class MoneroMultisigInfo {
    constructor(multisigInfo) {
        Object.assign(this, multisigInfo);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getIsMultisig() {
        return this.isMultisig;
    }
    setIsMultisig(isMultisig) {
        this.isMultisig = isMultisig;
        return this;
    }
    getIsReady() {
        return this.isReady;
    }
    setIsReady(isReady) {
        this.isReady = isReady;
        return this;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(threshold) {
        this.threshold = threshold;
        return this;
    }
    getNumParticipants() {
        return this.numParticipants;
    }
    setNumParticipants(numParticipants) {
        this.numParticipants = numParticipants;
        return this;
    }
}
